import styled from "styled-components";

export const ProjectMemberSc = styled.div`
  padding: 20px 30px;
  background-color: #b2b5fc;
  border-radius: 3px;
  transition: all 1s;
  color: black;
  margin: 1rem;
  :hover {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
`;
